import { useEffect, useState } from 'react';
import { getListPrice } from 'src/common/hooks/widgets/fetchData';
import { useCurrency } from 'src/common/hooks/widgets/useCurrency';
import {
  DISCOUNT_ESSENTIALS,
  DISCOUNT_STANDARD,
  YEARLY,
  tileInfo,
} from '../constant/spread';
import { ENVIZ_PN } from '../constant/prices';

export interface PropsFunc {
  appPoints: number;
  localeCode: string;
  currency: string;
  tileValue: string;
  country: string;
}

export interface priceProps {
  partNumber: string;
  pricingIndicator: string;
  pricingModel: number;
  scaleQtyPrice: [
    {
      qty: number;
      price: number;
    },
  ];
}
// "one discountFactor for all "
const partsToQuery = [
  {
    partNumber: ENVIZ_PN, // 50.-USD
  },
];

type MarketPlaceRequest = {
  currency: string;
  countryCode3: string;
  parts: typeof partsToQuery;
};

export const usePrice = ({
  appPoints,
  localeCode,
  currency,
  tileValue,
  country,
}: PropsFunc) => {
  const [dataFetched, setDataFetched] = useState([]);
  const [priceFile, setPriceFile] = useState({} as priceProps[]);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(0);
  const [fetchingError, setFetchingError] = useState({});
  const [totalCost, setTotalCost] = useCurrency(currency, localeCode, 0);
  const [totalCostMonthly, setTotalCostMonthly] = useCurrency(
    currency,
    localeCode,
    0,
  );
  const [listPrice, setListPrice] = useCurrency(currency, localeCode, 0);

  useEffect(() => {
    if (tileValue === tileInfo.est) {
      setTotalCostMonthly(Math.round(appPoints * price * DISCOUNT_ESSENTIALS));
      setTotalCost(
        Math.round(appPoints * price * DISCOUNT_ESSENTIALS * YEARLY),
      );
      setListPrice(Math.round(appPoints * price * YEARLY));
    } else if (tileValue === tileInfo.std) {
      setTotalCostMonthly(Math.round(appPoints * price * DISCOUNT_STANDARD));
      setTotalCost(Math.round(appPoints * price * DISCOUNT_STANDARD * YEARLY));
      setListPrice(Math.round(appPoints * price * YEARLY));
    }
  }, [appPoints, price, tileValue]);

  useEffect(() => {
    if (currency && dataFetched.length === 0) {
      fetchPrices();
    }
  }, [localeCode, currency, tileValue, country]);

  const fetchPrices = () => {
    setLoading(true);
    const body: MarketPlaceRequest = {
      currency: currency,
      countryCode3: country,
      parts: partsToQuery,
    };
    getListPrice(
      'https://api.marketplace.ibm.com/purchase/catalog/resources/price/info',
      JSON.stringify(body),
      'POST',
    )
      .then((data) => {
        if (data.parts && data.parts.length !== 0) {
          setPriceFile(data.parts);
          setDataFetched(data.parts);
          setLoading(false);
        } else {
          setDataFetched([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        setDataFetched([]);
        setLoading(false);
        if (error.response) {
          setFetchingError(error.response);
        }
      });
  };

  useEffect(() => {
    if (priceFile.length) {
      const priceArray = priceFile.map((item) => ({
        [item.partNumber]: item.scaleQtyPrice[0].price,
      }));
      const priceObj = Object.assign({}, ...priceArray);
      setPrice(priceObj.D09SJZX);
    }
  }, [priceFile]);

  return [totalCost, totalCostMonthly, loading, listPrice, fetchingError];
};

export default usePrice;
